// Reaload

$(function () {

  function setCaretPosition(element, position) {
    if (element.setSelectionRange) {
      element.focus();
      element.setSelectionRange(position, position);
    } else if (element.createTextRange) {
      var range = element.createTextRange();
      range.collapse(true);
      range.moveEnd('character', position);
      range.moveStart('character', position);
      range.select();
    }
  }

  function combineWithFormParameters($element, href) {
    if (href && $element.is("form")) {
      var params = $element.serialize()

      if (params.length > 0) {
        if (href.indexOf("?") > 0) {
          href = href + "&" + params;
        } else {
          href = href + "?" + params;
        }
      }
    }

    return href;
  }

  function createHistoryHref($element) {
    var href = $element.attr("href");

    if ($element.is("form")) {
      href = $element.attr("action")
    }

    return combineWithFormParameters($element, href)
  }

  function createAjaxHref($element) {
    var ajaxHref = $element.data("ajax-href");

    return combineWithFormParameters($element, ajaxHref);
  }

  function createAjaxTarget($element) {
    const ajaxTargetSelector = $element.data("ajax-target");
    var $ajaxTarget = $(ajaxTargetSelector);

    if ($ajaxTarget.length == 0) {
      $ajaxTarget = $element.closest(".jsReloadTarget");
    }

    if ($ajaxTarget.length == 0) {
      $ajaxTarget = null;
    }

    return $ajaxTarget;
  }

  function doReload(element, e, focusElement) {
    const $element = $(element);
    const $target = createAjaxTarget($element);
    const ajaxHref = createAjaxHref($element);
    const historyHref = createHistoryHref($element);
    console.log('doReload');

    if ($target && ajaxHref) {
      EUCUtils.reload(ajaxHref, $target, historyHref, function () {
        console.log('after reload');
        if (focusElement !== undefined) {
          $focusElement = $(focusElement);
          var currentValue = $focusElement.val();
          $focusElement.focus().val("").val(currentValue);

          setCaretPosition($focusElement[0], currentValue.length);
        }
      });
      e.preventDefault();
    }
  }

  $(document).on("click", ".jsReload:not(form)", function (e) {
    doReload(this, e)
  });

  $(document).on("submit", "form.jsReload", function (e) {
    doReload(this, e)
  });

  var observeValue = null;
  var timeout = null;

  $(document).on('input', '.jsObserveInput', function (e) {
    clearTimeout(timeout);
    var $input = $(this);
    var $form = $input.closest('form');
    if ($input.val() != observeValue) {
      observeValue = $input.val();
      timeout = setTimeout(function () {
        doReload($form, e, 'input.jsObserveInput');
      }, 500);
    }
  });

  $(document).bind("reload:completed", function () {
    $('[data-toggle="popover"]').popover({
      trigger: 'hover focus',
      placement: 'top',
      container: 'body',
    });
  });

  var $anchor = $('.jsReloadAnchor');
  if ($anchor.length > 0) {
    $('html, body').animate({
      scrollTop: ($anchor.first().offset().top)
    }, 500);
  }

});
